<template>
       <div>
        <el-row>
            <el-col :lg="10" :offset="2">
                品牌: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.getProductDetail.brand_id == 1 ? 'N牌': 'S牌'}}</el-tag>
            </el-col>
            <el-col :lg="10" :offset="2">
                系列別: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.class.name}}</el-tag>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">單品編號: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.getProductDetail.id}}</el-tag>
             
                
            </el-col>
            <el-col :lg="10" :offset="2">
                
             單品名稱: <el-tag type="info" effect="dark" style="font-size:18px;">{{this.getProductDetail.name}}</el-tag>
                   
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                特價品: {{this.getProductDetail.on_sale == true ? '是': '否'}}
            </el-col>
            <el-col :lg="10" :offset="2" v-if="isCheckSale">
                折扣期限: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.getProductDetail.on_sale_start}}</el-tag> - <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.getProductDetail.on_sale_end}}</el-tag> 
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
              售價: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.productDetail.price}}</el-tag>
                
                
            </el-col>
            <el-col :lg="10" :offset="2" v-if="isCheckSale">
                {{this.isBrand_1}}:<el-tag type="info" effect="dark"  style="font-size:18px;">{{this.productDetail.memberdiscount_1}}</el-tag>
                        
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2" v-if="isCheckSale">
               {{this.isBrand_2}}:<el-tag type="info" effect="dark"  style="font-size:18px;">{{this.productDetail.memberdiscount_2}}</el-tag>
                
                
            </el-col>
            <el-col :lg="10" :offset="2">
                業績: <el-tag type="info" effect="dark"  style="font-size:18px;">{{this.productDetail.performance_ratio}}</el-tag>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-image
                  v-for="item in iges"
                  :key="item"
                    style="width: 150px; height: 150px;margin-right:20px;"
                    :src="item.url"
                    :preview-src-list="url"
                    fit="fill"
                    ></el-image>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-button type="primary" @click="editTabs">編輯</el-button>
                <el-button type="default" @click="back">返回</el-button>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
       </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { async } from 'q'
    export default {
        name: 'Single',
        props: {
            type: Number,
            productKey: String
        },
        data() {
            return {
                      productDetail: [],
                bundleDetail: [],
                class: [],
                images: [],
                iges: [],
                url: [],
                isCheckSale: null,
                isBrand_1: '',
                isBrand_2: ''
            }
        },
          computed: mapGetters(["getProductDetail", "getClassList", "getImages"]),
        methods: {
            ...mapActions(["fetchProductDetail", "fetchClassList", "LoadFile" ]),
           async fetchProductDetail(){
                const data = await {type: this.type, _key:this.productKey}
                await this.$store.dispatch("fetchProductDetail", data)
                this.productDetail = await this.getProductDetail
                console.log(this.productDetail)
                this.class = this.productDetail.class
                
               

                if (this.productDetail.on_sale == true) {
                    this.isCheckSale = true
                     if (this.productDetail.brand_id == 1) {
                    this.isBrand_1 = '白金'
                    this.isBrand_2 = '尊爵'
                }else if (this.productDetail.brand_id == 2) {
                    this.isBrand_1 = '芙蓉'
                    this.isBrand_2 = '金鑽'
                }
                }else {
                    this.isCheckSale = false
                }
                              
               await this.fetchImage(this.productDetail.images)
               
              },
           
           async fetchImage (images){
               for (let i = 0; i < images.length; i++) {
                   
                   const key = await  images[i]._key
                  await this.$store.dispatch('LoadImgFile', key)
                     let src =  window.URL.createObjectURL(this.getImages)
                 await this.iges.push({
                      url:  src
                  })
                  this.url.push(
                      src
                  )
                   
               }
                  
           },
           async editTabs(){
               const data = await{type: this.type, key: this.productKey}
              await  this.$emit('editTabs', data)
           },
           async back(){
               await this.$emit('back')
           }
        },
          created() {
            this.fetchProductDetail()
            
        },
    }
</script>

<style lang="scss" scoped>
     .el-row {
        
        margin-bottom: 36px;
         font-weight: bold;
          font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
</style>